export default __webpack_public_path__ + "static/media/trainingIcon.3bbda6af.svg";